import { z } from 'zod';

export const branchAddressSchema = z.object({
  streetName: z.string().min(1, 'La calle es obligatoria'),
  doorNumber: z.string().min(1, 'El número es obligatorio'),
  apartmentNumber: z.string().optional().or(z.literal('')),
  corner: z.string().optional().or(z.literal('')),
  zipCode: z.string().optional().or(z.literal('')),
  neighborhoodId: z.string().optional().or(z.literal('')),
});

export type BranchAddressFormValues = z.infer<typeof branchAddressSchema>;

export const defaultBranchAddressValues: BranchAddressFormValues = {
  streetName: '',
  doorNumber: '',
  apartmentNumber: '',
  corner: '',
  zipCode: '',
  neighborhoodId: '',
};
